// components/NotFound.js
import React, { useEffect, useState } from "react";
import "./CSS/NotFound.css";

const NotFound = ({ onBackToHome, isMobile }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    // Generate floating particles
    const generateParticles = () => {
      const newParticles = Array.from({ length: 15 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 20 + 10,
        duration: Math.random() * 10 + 10,
        delay: Math.random() * 5,
      }));
      setParticles(newParticles);
    };

    window.addEventListener("mousemove", handleMouseMove);
    generateParticles();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="not-found-container">
      <br /> <br />
      {/* Animated Background */}
      <div className="animated-background">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="floating-particle"
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              width: particle.size,
              height: particle.size,
              animationDuration: `${particle.duration}s`,
              animationDelay: `${particle.delay}s`,
            }}
          />
        ))}
      </div>
      {/* Mouse Follow Glow */}
      <div
        className="mouse-glow"
        style={{
          left: mousePosition.x - 100,
          top: mousePosition.y - 100,
        }}
      />
      {/* Main Content */}
      <br /> <br />
      <br /> <br />
      <div className="not-found-content">
        <div className="error-animation">
          <div className="number-container">
            <div className="number-4 number-first">4</div>
            <div className="number-0">0</div>
            <div className="number-4 number-last">4</div>
          </div>

          <div className="broken-plate">
            <div className="plate-piece piece-1"></div>
            <div className="plate-piece piece-2"></div>
            <div className="plate-piece piece-3"></div>
            <div className="plate-piece piece-4"></div>
          </div>
        </div>

        <div className="error-text">
          <h1 className="error-title">Oops! Page Not Found</h1>
          <p className="error-message">
            It seems like the page you're looking for has been moved, deleted,
            or never existed. Maybe our chef took it to the kitchen!
          </p>
        </div>

        <div className="error-actions">
          <button className="home-button" onClick={onBackToHome}>
            <span className="button-icon">🏠</span>
            Back to Home
          </button>

          <button className="menu-button" onClick={() => onBackToHome()}>
            <span className="button-icon">🍽️</span>
            View Our Menu
          </button>
        </div>

        {/* Animated Food Icons */}
        <div className="floating-food-icons">
          <div className="food-icon">🍕</div>
          <div className="food-icon">🍔</div>
          <div className="food-icon">🍣</div>
          <div className="food-icon">🍰</div>
          <div className="food-icon">☕</div>
        </div>
      </div>
      {/* Decorative Elements */}
      <div className="decorative-corner corner-top-left"></div>
      <div className="decorative-corner corner-top-right"></div>
      <div className="decorative-corner corner-bottom-left"></div>
      <div className="decorative-corner corner-bottom-right"></div>
    </div>
  );
};

export default NotFound;
